import { atom } from "recoil";

export const componentState = atom ({
    key: "componentState",
    default: '',
});

